import { useCallback, useEffect, useState } from "react";
import APIutil from "api/APIutils";
import * as url from "api/url";
import { secureNetworkErrors,formErrorMessages, } from "./constants";
import { hubServerErrors } from "../ViewHubParameters/constants";
import { useSelector, useDispatch } from "react-redux";
import { getAllResources } from 'action/cultureAction';
//import { useDateTimeByUserFormat } from "utils";

export const useSecureNetworkAPIMethods = (setState, getNetworkList) => {
    const deleteSecureNetwork = useCallback((networkId) => {
        setState(prevState => ({ ...prevState, loading: true, apiError: "" }));
        APIutil.deleteAPI(`${url.delete_secure_network_link}/${networkId}`).then(response => {
            if (response && response.data && response.data.isSuccess === true) {
                setState(prevState => ({
                    ...prevState,
                    modal: false,
                    deleteItem: null
                }));
                getNetworkList();
            } else {
                const message = response && response.data &&  response.data.errors
                    && response.data.errors.siteConnected && secureNetworkErrors[response.data.errors.siteConnected.errorCode] ? secureNetworkErrors[response.data.errors.siteConnected.errorCode] : "Something went wrong. Please try again."
                setState(prevState => ({ ...prevState, loading: false, apiError: message }));
            }
        }).catch(error => {
            setState(prevState => ({ ...prevState, loading: false, apiError: "Something went wrong. Please try again." }));
            throw error;
        })
    }, [setState]);
    
    return {
        deleteSecureNetwork
    };
}

export const useFetchHubParamsData = (history) => {
    const { getMultipleErrorString } = useGetLocalizationLabel();

    const [state, setState] = useState({
        data: {},
        loading: false,
        error: false,
        errorMessage: "",
        certificateDetails: {
            rootCertDetails: null,
            issuerCertDetails: null,
            operationCertDetails: null
        },
        fileUploadError: "",
        fileUploading: false,
        hubRootCertName: "",
        hubOperationCertName: "",
        hubIssuCertName: "",
        issuerCertValidity: 0,
        OperationalCertValidity: 0,
        IssuerCertExpireDt: "",
        OperationalCertExpireDt: ""
    });

    //const { getDateTimeValue } = useDateTimeByUserFormat();
    
    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = useCallback((payload, suppressError) => {
        if (payload && (payload.editMode)) {
            return null;
        } else {
            setState(prevState => ({ ...prevState, loading: true }));
            APIutil.getDataAPI(url.get_hub_parameter_details).then(response => {
                if (response && !response.statusText) {
                    if (response.hubMode === "1") {
                        setState(prevState => ({ ...prevState,
                            loading: false,
                            data: response,
                            hubRootCertName: response.rootCertificate ? `${response.rootCertificate} expires on ${response.rootCertificateValidity}` : "",
                            // hubOperationCertName: response.operationalCertificate ? `${response.operationalCertificate} expires on ${response.operationalCertificateValidity}` : "",
                            error: false,
                            errorMessage: ""
                        }));
                    } else {
                        setState(prevState => ({ ...prevState, loading: false, data: response, hubRootCertName: ""}));
                    }
                } else {
                    const message = response && response.statusText ? response.statusText : "Something went wrong. Please try refreshing the page."
                    if (suppressError) {
                        setState(prevState => ({ ...prevState, loading: false }));
                    } else {
                        setState(prevState => ({ ...prevState, loading: false, error:true, errorMessage: message }));
                    }
                }
            }).catch(error => {
                if (suppressError) {
                    setState(prevState => ({ ...prevState, loading: false }));
                } else {
                    setState(prevState => ({ ...prevState, loading: false, error: true, errorMessage: "Something went wrong. Please try refreshing the page." }));
                }
                throw error;
            });
        }
    }, [setState]);

    const getCertificateDetails = useCallback((payload, suppressError) => {
        if (payload && (payload.editMode)) {
            return null;
        } else {
            setState(prevState => ({ ...prevState, loading: true }));
            Promise.all([
                APIutil.getDataAPI(url.get_root_cert_details), 
                APIutil.getDataAPI(url.get_issuer_cert_details),
                APIutil.getDataAPI(url.get_operational_cert_details),
                APIutil.getDataAPI(url.get_hub_server_status)
                ]).then(([response1, response2, response3, response4]) => {
                    setState(prevState => ({ ...prevState, loading: false, certificateDetails: {
                        rootCertDetails: (response1 && !response1.statusText) ? response1 : null,
                        issuerCertDetails: (response2 && !response2.statusText) ? response2 : null,
                        operationCertDetails: (response3 && !response3.statusText) ? response3 : null
                    },
                    hubServerStatus: (response4 && !response4.statusText) ? response4 : {}
                }));
            }).catch(error => {
                if (suppressError) {
                    setState(prevState => ({ ...prevState, loading: false }));
                } else {
                    setState(prevState => ({ ...prevState, loading: false, error: true, errorMessage: "Unable to get certificate details. Please try refreshing the page." }));
                }
                throw error;
            });
        }
    }, [setState]);

    const UpdateCertificateStates = useCallback((IssuerCertName, IssuerCertValidity, issuerCertData, OperationalCertName, OperationalCertValidity, operCertData) => {
        const IssuervalidTo = issuerCertData && issuerCertData.validTo && new Date(issuerCertData.validTo);
        const IssuercertificateExpireDate = IssuervalidTo && ` expires on ${IssuervalidTo.toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"}) }`;
        const OperationalvalidTo = operCertData && operCertData.validTo && new Date(operCertData.validTo);
        const OperationalcertificateExpireDate = OperationalvalidTo && ` expires on ${OperationalvalidTo.toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"}) }`;
                
        setState(prevState => ({ ...prevState, hubIssuCertName: IssuerCertName, issuerCertValidity: IssuerCertValidity, hubOperationCertName: OperationalCertName, OperationalCertValidity: OperationalCertValidity,
            IssuerCertExpireDt: IssuercertificateExpireDate, OperationalCertExpireDt: OperationalcertificateExpireDate }));
    })

    const convertToDate = (value) => {
        let validToDate;
        if(value.includes('-')){
            let validTo = value.split(' ')[0].split('-');
            let day = validTo[0];
            let month = validTo[1];
            let year = validTo[2];
            validToDate = new Date(month+' '+day+' '+year);
        }else{
            validToDate = new Date(value);
        }
        return  ` expires on ${validToDate.toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"}) }`
    }

    const UpdateExistingCertificateStates = useCallback((IssuerCertName, IssuerCertValidity, issuerCertData, OperationalCertName, OperationalCertValidity, operCertData) => {
        const IssuercertificateExpireDate = issuerCertData && convertToDate(issuerCertData);
        const OperationalcertificateExpireDate = operCertData && convertToDate(operCertData);                
        setState(prevState => ({ ...prevState, hubIssuCertName: IssuerCertName, issuerCertValidity: IssuerCertValidity, hubOperationCertName: OperationalCertName, OperationalCertValidity: OperationalCertValidity,
            IssuerCertExpireDt: IssuercertificateExpireDate, OperationalCertExpireDt: OperationalcertificateExpireDate }));
    })
       
    const submitForm = useCallback((payload, callbackFunction, fileUploadKey, mode, networkID) => {
        let urlValue = url.update_hub_parameter_details;
        if (fileUploadKey) {
            urlValue = fileUploadKey === "issuerCertFile" ? `${url.upload_root_certificate}/${mode}` : `${url.upload_operational_certificate}/${mode}/${networkID}`;
            setState(prevState => ({ ...prevState, fileUploadError: "", fileUploading: true }));
        } else {
            setState(prevState => ({ ...prevState, loading: true, error: false, errorMessage: "" }));
        }
        APIutil.postImage(urlValue, payload).then(response => { 
            if (response && response.data && response.data.errorCode === "ERRCE0000" && fileUploadKey) {
                callbackFunction && callbackFunction("success");
                const validFrom = new Date(response.data.validFrom);
                const validTo = new Date(response.data.validTo);
                const certificateValidity = ((validTo.getFullYear() - validFrom.getFullYear()));
                const certificateName = `${response.data.certSubject}`;
                const certificateExpireDate = ` expires on ${validTo.toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"}) }`;
                if (fileUploadKey === "issuerCertFile") {  
                    setState(prevState => ({ ...prevState, fileUploading: false, hubIssuCertName: certificateName, issuerCertValidity: certificateValidity, IssuerCertExpireDt: certificateExpireDate }));
                } else {
                    setState(prevState => ({ ...prevState, fileUploading: false, hubOperationCertName: certificateName, OperationalCertValidity: certificateValidity, OperationalCertExpireDt: certificateExpireDate}));
                }
            } else if(!fileUploadKey && response && response.status === 200){
                callbackFunction && callbackFunction("success");
                setState(prevState => ({ ...prevState, loading: false }));
            } else {
                const errorValue = response.statusText ? response.statusText : "Something went wrong please try again.";
                if (fileUploadKey) {
                    setState(prevState => ({ ...prevState,
                        fileUploadError: response.data.errorCode ? getMultipleErrorString(response.data.errorCode, ",") :  errorValue,
                        fileUploading: false }));
                } else {
                    setState(prevState => ({ ...prevState, loading: false, errorMessage: errorValue, error: true }));
                }
                callbackFunction && callbackFunction("error", { message: errorValue });
            }
        }).catch(error => {
            if (fileUploadKey) {
                setState(prevState => ({ ...prevState, fileUploadError: "Something went wrong please try again.", fileUploading: false }));
            } else {
                setState(prevState => ({ ...prevState, loading: false, errorMessage: "Something went wrong please try again.", error: true }));
            }
            callbackFunction && callbackFunction("error", error);
            throw error;
        });
    }, [setState]);

    
    return {
        data: state.data,
        loading: state.loading,
        error: state.error,
        errorMessage: state.errorMessage,
        setAPIHookData: setState,
        hubIssuCertName: state.hubIssuCertName,
        hubOperationCertName: state.hubOperationCertName,
        issuerCertValidity: state.issuerCertValidity,
        OperationalCertValidity: state.OperationalCertValidity,
        IssuerCertExpireDt: state.IssuerCertExpireDt,
        OperationalCertExpireDt: state.OperationalCertExpireDt,
        refetch: fetchData,
        fileUploadError: state.fileUploadError,
        fileUploading: state.fileUploading,
        submitForm,
        certificateDetails: state.certificateDetails,
        getCertificateDetails,
        UpdateCertificateStates,
        UpdateExistingCertificateStates
    };
}

export const useDownloadCSRCertificate = (fileName) => {
    const [state, setState] = useState({
        loading: false,
        error: false,
        errorMessage: ""
    });

    const downloadCSRCertificate = useCallback((fileName) => {
        setState(prevState => ({ ...prevState, loading: true }));
        APIutil.getPDFDataAPI(url.generate_new_csr_certificate)
            .then(response => {
                if (response && !response.statusText) {
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(new Blob([response]), fileName);
                    } else {
                        const url = window.URL.createObjectURL(new Blob([response]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                    }
                    setState(prevState => ({ ...prevState, loading: false }));
                } else {
                    const messageContent = "Unable to generate new CSR certificate. Please try again."
                    setState(prevState => ({ ...prevState, error: true, errorMessage: messageContent }));
                }
            })
            .catch(error => {
                const messageContent = "Unable to generate new CSR certificate. Please try again."
                setState(prevState => ({ ...prevState, error: true, errorMessage: messageContent }));
                throw error;
            });
    }, [setState]);

    return {
        loading: state.loading,
        error: state.error,
        errorMessage: state.errorMessage,
        downloadCSRCertificate
    };
}

export const useGetLocalizationLabel = () => {
    const systemAdminLabels = useSelector(state => state.CulturalLabelsRootReducer.SystemAdmin_LabelsBasedOnPreference);
    const dispatch = useDispatch();
    useEffect(() => {
        if (systemAdminLabels["ManageBACNetSecureNetworks.HeaderTitle.Text"] === undefined) {
            dispatch(getAllResources());
        }
    }, []);

    const getLabel = (labelKey) => {
        if (systemAdminLabels && systemAdminLabels[`ManageBACNetSecureNetworks.${labelKey}.Text`]) {
            return systemAdminLabels[`ManageBACNetSecureNetworks.${labelKey}.Text`];
        } else {
            return "";
        }
    }

    const getAPIErrorLabel = (errorKey) => {
        if (systemAdminLabels && systemAdminLabels[`ManageBACNetSecureNetworks.Error.${errorKey}.Text`]) {
            return systemAdminLabels[`ManageBACNetSecureNetworks.Error.${errorKey}.Text`];
        } else {
            return hubServerErrors[errorKey] ? hubServerErrors[errorKey] : "Undefined error";
        }
    };

    const getFormErrorLabel = (errorKey) => {
        if (systemAdminLabels && systemAdminLabels[`ManageBACNetSecureNetworks.Error.${errorKey}.Text`]) {
            return systemAdminLabels[`ManageBACNetSecureNetworks.Error.${errorKey}.Text`];
        } else {
            return formErrorMessages[errorKey] ? formErrorMessages[errorKey] : "Invalid Input";
        }
    };

    const getMultipleErrorString = (stringData, splitBy=",", replaceBy=" ") => {
        const searchRegExp = / /gi;
        if (stringData && stringData.length && splitBy) {
            let newErrorString = "";
            const updatedString = stringData.replace(searchRegExp, "");
            updatedString.split(splitBy).map(errorCode => {
                if (newErrorString === "") {
                    newErrorString = `${getAPIErrorLabel(errorCode)}`;
                } else {
                    newErrorString = `${newErrorString}, ${getAPIErrorLabel(errorCode)}`;
                }
                return errorCode;
            });
            return newErrorString;
        } else {
            return getAPIErrorLabel(stringData.replace(searchRegExp, ""));
        }
    }

    return {
        systemAdminLabels,
        getLabel,
        getAPIErrorLabel,
        getMultipleErrorString,
        getFormErrorLabel,
        formErrorMessages,
        hubServerErrors
    }
}

export const useTestConnectionLink = () => {
    const getTestConnectionLink = useCallback((payload,callBackFunction) => {
         APIutil.postData(url.test_secure_network_link, payload)
            .then(response => {
                if(response && response.status === 200){
                    getTestConnectionLinkStatus(payload, callBackFunction);
                }else{
                    const message = "BACnet SC TLS: Server authentication failed.";
                    callBackFunction && callBackFunction('error', {message});
                }
            })
            .catch(error => {
                callBackFunction && callBackFunction('error',error);
                throw error;
            })
        })

     const getTestConnectionLinkStatus = useCallback((payload, callBackFunction) => {
        APIutil.postData(url.test_secure_network_link_status, payload)
            .then(response => {
                if(response && response.status === 200){
                    callBackFunction && callBackFunction('success');
                }else{
                    const message = "BACnet SC TLS: Server authentication failed.";
                    callBackFunction && callBackFunction('error',{message});
                }
            })
            .catch(error => {
                callBackFunction && callBackFunction('error',error);
                throw error;
            })
    })
 // New method
    return{
        getTestConnectionLink,
    }
}
export const useAddSecureConnectNetworkPort = (networkID, isEdit)=>
{

    let l_apiURL = isEdit ? url.secure_connect_updatenetworkPort : url.secure_connect_networkPort;
    return APIutil.postData(l_apiURL + "/" + networkID)
    .then(response => {
        if(response && response.status === 200)
        {
            console.log("Network Object has been added successfully");
        } else
        {
            console.log("Network Object has not been added");
        }
    })
    .catch(error => {
         throw error;
    })
}